const getIterableBackeundUrl = require("../common/getIterableBackendUrl");

module.exports = class Config {
	constructor (environment) {
		this.environment = environment;
	}

	getIterableBackendBaseUrl () {
		return getIterableBackeundUrl();
	}
}